import './SearchBar.css';
import React from 'react';
import { useState } from 'react';

const SearchBar = ({onSubmit}) => {
    const [term, setTerm] = useState('');

    const handleFormSubmit = (event) =>{
        // for preventing the default behaviour of form 
        event.preventDefault();
 onSubmit(term);
    }
    const handleChange=(event)=>{
       setTerm(event.target.value)
    }
    return (
        <div className='inputgroup text-center'>
            <form className='Searchbar-form' onSubmit={handleFormSubmit}>
                 <label><h1>Enter search Term</h1></label>
                <input className='form-control' value={term} onChange={handleChange} type="text" />        
            </form>
        </div>
    );
}

export default SearchBar;
